var map = {
	"./de.json": [
		1705,
		41
	],
	"./en-AU.json": [
		1706,
		42
	],
	"./en-GB.json": [
		1707,
		43
	],
	"./en-HK.json": [
		1708,
		44
	],
	"./en-SG.json": [
		1709,
		45
	],
	"./en-us.json": [
		1710,
		46
	],
	"./fr.json": [
		1711,
		47
	],
	"./global.json": [
		1712,
		48
	],
	"./it.json": [
		1713,
		49
	],
	"./zh-Hant.json": [
		1714,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1702;
module.exports = webpackAsyncContext;